import React, { Component } from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import NavMenu from './NavMenu';

export class Layout extends Component {
    displayName = Layout.name

    render() {
        return (
            <Container fluid>
                <Row>
                    <Col sm={12} style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <NavMenu />
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} style={{ paddingLeft: 0, paddingRight: 0 }}>
                        {this.props.children}
                    </Col>
                </Row>
            </Container>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout.js